export const tokenMovedFromPendingAlertDisabledStatus = ['NOT STARTED', 'PAUSED', 'STOPPED']

export const newBookingAlertDisabledStatus = ['NOT STARTED', 'PAUSED', 'STOPPED']
